import React, {useState, useEffect} from 'react';
import {useIntl} from 'react-intl';
import Level3Title from '../../../common/components/title/Level3Title';

interface NewsItem {
  id: number;
  title: {rendered: string};
  excerpt: {rendered: string};
  link: string;
  date: string;
  _embedded?: {'wp:featuredmedia': [{source_url: string}]};
}

interface LatestNewsProps {
  header?: React.ReactNode;
  fullWidth?: boolean;
}

function LatestNews({header, fullWidth = false}: LatestNewsProps) {
  const intl = useIntl();
  const [news, setNews] = useState<NewsItem[]>([]);

  useEffect(() => {
    const apiUrl = 'https://www.celeste.fr/wp-json/wp/v2/posts?per_page=4&_embed';

    fetch(apiUrl)
      .then((response) => response.text())
      .then((html) => {
        // Extract JSON data from the HTML response
        const jsonStartIndex = html.indexOf('[');
        const jsonEndIndex = html.lastIndexOf(']') + 1;
        const jsonData = html.substring(jsonStartIndex, jsonEndIndex);

        // Parse the extracted JSON data
        const parsedData = JSON.parse(jsonData);

        setNews(parsedData);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, []);

  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className={fullWidth ? '' : 'mx-5'}>
      {header ?? (
        <>
          <br/><br/>
          <Level3Title title={intl.formatMessage({id: 'MENU.DASHBOARD.NEWS.TITLE'})} />
          <a
            href={'https://www.celeste.fr/le-blog/'}
            target="_blank"
            rel="noreferrer"
            className="pb-5"
            style={{fontSize: '14px', fontWeight: '400'}}
          >
            {intl.formatMessage({id: 'MENU.DASHBOARD.NEWS.LATEST'})}
          </a>
        </>
      )}
      <div className={fullWidth ? '' : 'py-5'} style={fullWidth ? undefined : {"marginLeft": "-9px"}}>
        <div className={fullWidth ? 'row row-cols-2 row-cols-md-4 g-4' : 'row row-cols-2 row-cols-md-4 g-4 py-5'}>
          {news.map((item) => {
            const imgStyle: React.CSSProperties = fullWidth
              ? {width: '100%', height: 170, objectFit: 'cover', display: 'block', margin: 0}
              : {maxWidth: '100%', height: 'auto', margin: 0};
            const card = (
              <a
                href={item.link}
                target="_blank"
                rel="noreferrer"
                className={fullWidth ? 'text-center d-block h-100' : 'text-center'}
                style={{
                  "padding": "0px",
                  "margin": fullWidth ? "0" : "0px 10px",
                  "width": fullWidth ? "100%" : "285px",
                  "borderRadius": "7px",
                  "overflow": "hidden",
                  "backgroundColor": "#fff",
                  "border": "1px solid #e6e6e6"
                }}
              >
                {item._embedded?.['wp:featuredmedia']?.[0]?.source_url ? (
                  <img
                    src={item._embedded['wp:featuredmedia'][0].source_url}
                    alt={item.title.rendered}
                    style={imgStyle}
                  />
                ) : (
                  <img
                    src="https://www.celeste.fr/wp-content/uploads/2023/02/Communique-de-presse-CELESTE.png"
                    alt="press"
                    style={imgStyle}
                  />
                )}
                <p style={{fontSize: '12px', marginBottom: '4px', textAlign: 'center', "marginTop": "6px"}}>
                  {formatDate(item.date)}
                </p>
                <h3
                  style={{
                    "textAlign": "center",
                    "fontSize": "15px",
                    "letterSpacing": "-0.3px",
                    "lineHeight": "21px",
                    "marginTop": "17px",
                    "marginBottom": "25px",
                    "padding": "0 22px"
                  }}
                  dangerouslySetInnerHTML={{__html: item.title.rendered}}
                />
              </a>
            );
            return fullWidth ? (
              <div key={item.id} className="col">
                {card}
              </div>
            ) : (
              <React.Fragment key={item.id}>{card}</React.Fragment>
            );
          })}
        </div>
      </div>

    </div>
  );
}

export default LatestNews;
